





















import {Component, Prop, Vue} from 'vue-property-decorator';
import {MenuPosition} from '@/layouts/back-office/aside/MenuPosition';

export interface AsideMenuItem {
  name?: string | null;
  title: string;
  icon: string|string[];
  path?: string | null;
  permission?: string | string[] | null;
  action?: () => void;
  menuPosition?: MenuPosition;
}

@Component({})
export default class AsideItem extends Vue {
  @Prop(Object) protected item!: AsideMenuItem;
  @Prop(Boolean) protected open!: boolean;
}
